/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Read_Full_NoticeInputs */



/**
* | output |
* | --- |
* | "Read full usage notice →" |
*
* @param {Guardrails_Read_Full_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_read_full_notice = /** @type {((inputs?: Guardrails_Read_Full_NoticeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Read_Full_NoticeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollständigen Nutzungshinweis anzeigen →")
	return /** @type {LocalizedString} */ ("Read full usage notice →")
});